import { QueryResponse } from 'global';
import { useQuery } from '@apollo/client';

import { userAdditionalAccountsApi } from './index';
import { AdditionalAccountsAPINameSpase } from './types';

export function useUserAdditionalAccountsCheck() {
  const { data, loading, error } = useQuery<AdditionalAccountsAPINameSpase<QueryResponse<boolean>>>(
    userAdditionalAccountsApi.checkIsSwitchAccountsEnabled
  );

  return {
    error,
    hasAdditionalAccountsLoading: loading,
    hasAdditionalAccounts: data?.additionalAccount?.result?.entity || false,
  };
}
